import { render } from "./InsuranceView.vue?vue&type=template&id=397f8842"
import script from "./InsuranceView.vue?vue&type=script&lang=js"
export * from "./InsuranceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__